"use client";

import { c as _c } from "react/compiler-runtime";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import VotingModal from "@/components/voting/VotingModal";
import { useVotingModalState } from "@/components/voting/useVotingModalState";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { SingleWaveDropContent } from "./SingleWaveDropContent";
import { SingleWaveDropInfoContainer } from "./SingleWaveDropInfoContainer";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { WaveDropMetaRow } from "./WaveDropMetaRow";
import { WaveDropVoteSummary } from "./WaveDropVoteSummary";
interface SingleWaveDropInfoPanelProps {
  readonly drop: ExtendedDrop;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const SingleWaveDropInfoPanel = t0 => {
  const $ = _c(32);
  const {
    drop,
    isVotingClosed: t1,
    isVotingControlsLocked: t2
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const isVotingControlsLocked = t2 === undefined ? false : t2;
  const {
    canDelete,
    canShowVote,
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  const isChatWave = drop.drop_type === ApiDropType.Chat;
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const {
    isOpen: isVotingOpen,
    open: openVoting,
    close: closeVoting
  } = useVotingModalState(isVotingActionLocked);
  const canShowVotingAction = canShowVote && !isVotingActionLocked;
  const shouldShowVotingEndedSummary = isVotingEnded || isVotingClosed;
  let t3;
  if ($[0] !== drop) {
    t3 = <div className="tw-mb-6"><SingleWaveDropContent drop={drop} /></div>;
    $[0] = drop;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== canShowVotingAction || $[3] !== drop || $[4] !== isChatWave || $[5] !== isWinner || $[6] !== openVoting || $[7] !== shouldShowVotingEndedSummary) {
    t4 = !isChatWave && <div className="tw-mb-6 tw-flex tw-justify-center"><WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={shouldShowVotingEndedSummary} canShowVote={canShowVotingAction} onVoteClick={openVoting} /></div>;
    $[2] = canShowVotingAction;
    $[3] = drop;
    $[4] = isChatWave;
    $[5] = isWinner;
    $[6] = openVoting;
    $[7] = shouldShowVotingEndedSummary;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== drop || $[10] !== isWinner) {
    t5 = <WaveDropMetaRow drop={drop} isWinner={isWinner} />;
    $[9] = drop;
    $[10] = isWinner;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== drop || $[13] !== isChatWave) {
    t6 = !isChatWave && <div className="tw-mt-6"><SingleWaveDropInfoDetails drop={drop} /></div>;
    $[12] = drop;
    $[13] = isChatWave;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== canDelete || $[16] !== drop) {
    t7 = canDelete && drop.drop_type !== ApiDropType.Winner && <div className="tw-w-full tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pb-6 tw-pt-6"><WaveDropDeleteButton drop={drop} /></div>;
    $[15] = canDelete;
    $[16] = drop;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <SingleWaveDropInfoContainer><div className="tw-px-4 tw-pb-8 @[640px]:tw-px-8 @[640px]:tw-pb-10"><div className="tw-mx-auto tw-max-w-3xl">{t3}{t4}{t5}{t6}{t7}</div></div></SingleWaveDropInfoContainer>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== closeVoting || $[25] !== drop || $[26] !== isChatWave || $[27] !== isVotingOpen) {
    t9 = !isChatWave && <VotingModal drop={drop} isOpen={isVotingOpen} onClose={closeVoting} />;
    $[24] = closeVoting;
    $[25] = drop;
    $[26] = isChatWave;
    $[27] = isVotingOpen;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t8 || $[30] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};